export enum ErrorCode {
  Validation = 'validation_error',
  ApiError = 'api_error',
  CardCountryDoesNotMatchSiteCountry = 'card_country_does_not_match_site_country',
  EmailNotUnique = 'email_not_unique',
  RedemptionBenefitAlreadyBeenRedeemed = 'redemption_benefit_already_been_redeemed',
  RedemptionBenefitFullyBooked = 'benefit_fully_booked',
  NotFound = 'not_found',
  InvalidActivationToken = 'invalid_activation_token',
  BenefitsApiResponseError = 'benefits_api_response_error',
  OnDemandBookingExists = 'ondemand_video_event_booking_exists',
  ActivationToken = 'activation_token',
  IncorrectOldPassword = 'incorrect_old_password',
  SameAsPrevious = 'same_as_previous',
  WrongSecurityQuestionAnswer = 'wrong_security_question_answer',
}
